import { render, staticRenderFns } from "./CompanyDetailScreen.vue?vue&type=template&id=3f761f8f&scoped=true&lang=pug"
import script from "./CompanyDetailScreen.vue?vue&type=script&lang=ts"
export * from "./CompanyDetailScreen.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDetailScreen.vue?vue&type=style&index=0&id=3f761f8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f761f8f",
  null
  
)

export default component.exports